import React, {useEffect, useState} from 'react';
import {collection, addDoc, query, onSnapshot} from "firebase/firestore";
import db from "../../firebase";
import { useForm } from "react-hook-form";

const modalStyle = {
  marginLeft: 3,
  marginRight: 3
}
const CardModal = (props) => {
  const {statuses} = props
  const [priorities, setPriorities] = useState([]);
  const { register, handleSubmit, reset} = useForm({mode: 'onChange'}, { defaultValues: {
	  title: '',
	  status: '',
	  priority: '',
	  description: ''
	}});

  const clearForm = () => {
	const forms = document.querySelectorAll('.needs-validation')
	Array.from(forms).forEach(form => {
	  form.classList.remove('was-validated')
	})
  }
  const onSubmit = async (data) => {
	console.log(data);
	if(data) {
	  const docRef = await addDoc(collection(db, "cards"), {
		title: data.title,
		description: data.description,
		status: data.status,
		priority: +data.priority
	  });
	  console.log("Document written with ID: ", docRef.id);
	}
	reset({
	  title: '',
	  status: '',
	  priority: '',
	  description: ''
	})
	clearForm()
	alert('Your card was created successfully! You can close the modal now by clicking on "X" or Cancel button or create another card.')
  }

  const getPriorities = () => {
	const prioritiesColRef = query(collection(db, "priorities"));
	onSnapshot(prioritiesColRef, (snapshot) => {
	  setPriorities(
		snapshot.docs.map((doc) => ({
		  id: doc.id,
		  ...doc.data(),
		}))
	  );
	});
  }

  useEffect(() => {
	getPriorities();
  }, [])

  return (
	<>
	  <button type="button" className="btn btn-outline-secondary shadow p-2 mb-2"
			  data-bs-toggle="modal"
			  data-bs-target="#cardModal"
	  >
		Create card
	  </button>
	   <div className="modal fade"
		   id="cardModal"
		   tabIndex="-1"
		   aria-hidden="true"
		   aria-labelledby="cardModalLabel"
		   data-bs-backdrop="false" data-bs-keyboard="false"
	  >
		<div className="modal-dialog">
		  <div className="modal-content">
			<div className="modal-header">
			  <h1 className="modal-title fs-5" id="cardModalLabel">Create new task</h1>
			  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div className="modal-body">
			</div>
			<form action='#'
			  className="row g-3 needs-validation" noValidate
				  onSubmit={handleSubmit(onSubmit)}>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="summary" className="col-sm-2 col-form-label">Summary*</label>
				<div className="col-sm-10">
				  <input type="text" className="form-control" id="summary"
						 defaultValue=""
						 required
						 {...register("title")}/>
				  <div className="invalid-feedback">
					This field is required.
				  </div>
				</div>
			  </div>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="description" className="col-sm-2 col-form-label">Description</label>
				<div className="col-sm-10">
				  <textarea className="form-control"  id="description"
							defaultValue=""
							{...register("description")}>
				  </textarea>
				</div>
			  </div>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="priority" className="col-sm-2 col-form-label">Priority*</label>
				<div className="col-sm-10">
				  <select className="form-select form-select-sm" id="priority"
						  required
						  {...register("priority")}>
					<option selected disabled value="">Select priority</option>
					{priorities.map(el => {
					  return <option value={el.name} key={el.id}>{el.name}</option>
					})}
				  </select>
				  <div className="invalid-feedback">
					Please select a valid priority.
				  </div>
				</div>
			  </div>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="status" className="col-sm-2 col-form-label">Status*</label>
				<div className="col-sm-10">
				  <select className="form-select form-select-sm" id="status"
						  required
						  {...register("status")}>
					<option selected disabled value="">Select status</option>
					{statuses.map(el => {
					  return <option value={el.name} key={el.id}>{el.name}</option>
					})}
				  </select>
				  <div className="invalid-feedback">
					Please select a valid status.
				  </div>
				</div>
			  </div>
			  <div className="modal-footer">
			  <button type="submit" className="btn btn-outline-success shadow p-1 mb-2"
					  data-bs-target="#cardModal"
			  >Save</button>
			  <button type="button" className="btn btn-outline-danger shadow p-1 mb-2"
					  onClick={clearForm}
					  data-bs-dismiss="modal">Cancel</button>
			</div>
			</form>
		  </div>
		</div>
	  </div>
	</>
  );
};

export default CardModal;
